var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"slide-submit-button-wrapper",class:{
    'slide-submit-button-wrapper--loading': _vm.loading,
  }},[_vm._t("default",null,{"loading":_vm.loading,"disabled":_vm.disabled})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }